module.exports = __webpack_public_path__ + "img/lg_ring_y_c_1_0.53b23998.png";